import { Skeleton } from "@mui/material";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useMemo, useState } from "react";
import { X } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { useLastRoute } from "../../controllers/LastRouteContext";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import NoDataFound from "../Main/NoDataFound";
import Notification from "../Notification";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
  RichTextEditor,
  SelectComponent,
} from "@shopeasy-dashboard-ui/ui-library";

const UpdateFaq = () => {
  const params = useParams();
  const [elem, setElem] = useState();
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [nodata, setNodata] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [err, setErr] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [faqData, setFaqData] = useState("");
  const [value, setValue] = useState("");
  const [confirmationPP, setconfirmationPP] = useState(false);
  const [isChanges, setIsChanges] = useState(false);
  const [formSpinner, setFormSpinner] = useState(true);
  const lastRoute = useLastRoute();
  const [faqtype, setFaqtype] = useState("");
  const [faqpages, setFaqPages] = useState([]);
  const [faqLoading, setFaqLoading] = useState(false);
  const [faqSelected, setFaqSelected] = useState([]);

  // Get Faq
  const getPerticularFAQ = async () => {
    setFormSpinner(true);
    try {
      let data = await API({ url: `/admin/faq/GetFaqsById/${params.faq_id}`, method: "get" });
      const result = data?.data;
      setElem(result?.data);
      setFaqData(result?.data?.question);
      setFaqtype(result?.data?.faq_type);
      setValue(result?.data?.answer);
      setFaqSelected(result?.data?.path);
      setFormSpinner(false);
    } catch (error) {
      setNodata(true);
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const removeSelectdPath = (e, link) => {
    e.preventDefault();
    const filterSelectedPath = faqSelected?.filter((x) => x?.link !== link);
    setFaqSelected(filterSelectedPath);
  };

  const getFaqPages = async (type) => {
    try {
      setFaqLoading(true);
      const apiCall = await API({
        url: "/admin/faq/GetFaqLinkList",
        method: "get",
        params: { type },
      });
      return apiCall?.data?.templates || [];
    } catch (error) {
      console.error("FAQ page error:", error);
      return [];
    } finally {
      setFaqLoading(false);
    }
  };

  useEffect(() => {
    const fetchFaqPages = async () => {
      const data = await getFaqPages(faqtype);
      setFaqPages(data);
    };
    if (faqtype) fetchFaqPages();
  }, [faqtype]);

  const [btnLoading, setBtnLoading] = useState(false);
  const isAnswerEmpty = useMemo(() => {
    if (!value) return true;

    // Remove HTML tags
    const text = value
      .replace(/<style[^>]*>.*?<\/style>/gi, "")
      .replace(/<script[^>]*>.*?<\/script>/gi, "")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  }, [value]);

  const HandleUpdate = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    if (params.fromProduct === "true" && isChanges && faqSelected?.length > 1) {
      setconfirmationPP(true);
    } else {
      let body = {
        question: faqData,
        answer: value,
        faq_type: faqtype,
        path: faqSelected.map((x) => ({
          link: x.link,
          name: x.name,
        })),
      };
      try {
        const payload = body;
        const data = await API({
          url: `/admin/faq/updateFaq/${params.faq_id}`,
          method: "put",
          data: payload,
        });
        if (data.status === 200 || data.status === 304) {
          setSaveChanges({
            isUnsaveChanges: false,
            showChangesPopup: false,
            backLink: "/faqs",
            title: "edit faqs",
          });
          parentNavigate(lastRoute);
        }
      } catch (error) {
        setIsNotification(true);
        setNotificationMsg(error);
        setSeverity("error");
      }
    }
    setBtnLoading(false);
  };

  useEffect(() => {
    getPerticularFAQ();
  }, []);

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  //Quil To HTML code and Functions
  const handleQuillChange = (val) => {
    setValue(val);
  };
  const [html, setHtml] = useState({ htmlPP: false, code: "" });

  const saveHTML = (val) => {
    setHtml({ ...html, htmlPP: false });
    setValue(val);
  };
  const closeCode = () => {
    setHtml({ ...html, htmlPP: false });
  };
  const [warn, setwarn] = useState(false);
  const [AiLoader, setAiloader] = useState(false);

  const generateAnswer = async () => {
    setAiloader(true);
    if (faqData?.length === 0) {
      setwarn(true);
    } else {
      setwarn(false);
      try {
        const payload = {
          question: faqData,
        };
        let ApiCall = await API({
          url: "/admin/ai/answer_from_questionFAQ",
          method: "post",
          data: payload,
        });
        if (ApiCall.status === 200 || ApiCall.status === 304) {
          const result = ApiCall?.data;
          setValue(result?.data);
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          setIsNotification(true);
          setNotificationMsg(t("lang_Hit_chatgpt_limit"));
          setSeverity("warning");
        } else {
          setIsNotification(true);
          setNotificationMsg(error?.response?.data?.message);
          setSeverity("error");
        }
      } finally {
        setAiloader(false);
      }
    }
  };

  useEffect(() => {
    if (isChange) {
      setSaveChanges({
        backLink: "/faqs",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "edit faqs",
      });
    }
  }, [isChange]);

  const checkChanges = () => {
    if (isChange) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/faqs",
        title: "edit faqs",
      });
    } else {
      parentNavigate(lastRoute);
    }
  };

  const isSubmitDisabled =
    faqData === "" ||
    isAnswerEmpty === true ||
    (faqtype !== "" && !faqSelected?.length);

  return nodata ? (
    <NoDataFound />
  ) : (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}

      <div className="h-auto overflow-y-auto pb-[65px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_faqs"), path: lastRoute },
                    { name: t("lang_Update_FAQ"), path: "/faqs/update" },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Update_FAQ")}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="space-y-4">
              {formSpinner ? (
                <div className="secondary-bg-color shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
                  <div className="flex items-center space-x-4 w-full">
                    <div className="w-full">
                      <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                      <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                    </div>
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[150px]" variant="rounded-[6px]" />
                  </div>
                </div>
              ) : (
                <>
                  <DetailsComponent
                    open={true}
                    hasHr={false}
                    showChevron={false}
                    className="!pt-5 sm:!pt-[25px]"
                  >
                    <div className="mb-4">
                      <InputComponent
                        id="question"
                        name="question"
                        label={t("lang_Question")}
                        required={true}
                        value={faqData}
                        onChange={(e) => {
                          setFaqData(e.target.value);
                          setIsChange(true);
                          setIsChanges(true);
                          setwarn(false);
                        }}
                        placeholder="Write your question"
                        error={
                          err && faqData.length === 0
                            ? t("lang_Please_Enter_Question")
                            : ""
                        }
                        helpText={
                          warn
                            ? t("lang_Please_Enter_Question_To_Generate_Answer")
                            : ""
                        }
                      />
                    </div>
                    <div className="mb-4">
                      <div className="flex justify-between items-center mb-1">
                        <label htmlFor="Answer">
                          <p className="text-[13px] font-medium text-[var(--primary-text-color)] m-0">
                            {t("lang_Answer")}
                            <span className="text-red-500 ms-1">*</span>
                          </p>
                        </label>
                        <div className="flex items-center">
                          <span
                            className="inline-flex items-center cursor-pointer hover:underline text-[13px] rounded-[6px] transition duration-300 px-1"
                            onClick={() => generateAnswer()}
                          >
                            <BardSvg /> {t("lang_Get_Answer")}
                          </span>
                        </div>
                      </div>
                      <RichTextEditor
                        htmlData={value}
                        setHtmlData={handleQuillChange}
                        uplaodImageFile={uploadTextEditorImage}
                      />
                      {err && isAnswerEmpty ? (
                        <p className="text-red-500 font-medium text-xs mt-1">
                          {t("lang_Please_Enter_Answer")}
                        </p>
                      ) : null}
                    </div>
                    <div className="w-full">
                      <SelectComponent
                        id="faqtype"
                        name="faqtype"
                        label={t("lang_FAQ_Type")}
                        required={true}
                        value={faqtype}
                        onChange={(e) => {
                          setFaqtype(e.target.value);
                          setIsChange(true);
                          setFaqSelected([]);
                        }}
                        options={[
                          { value: "pages", label: t("lang_pages") },
                          { value: "product", label: t("lang_Product") },
                          { value: "category", label: t("lang_category") },
                          { value: "blog", label: t("lang_blog") },
                        ]}
                      />
                    </div>
                    {faqpages?.length > 0 && (
                      <div className="mt-4">
                        <SelectComponent
                          id="faqPath"
                          name="faqPath"
                          label={t("lang_path")}
                          required={true}
                          placeholder="Select Path"
                          loading={faqLoading}
                          value=""
                          onChange={(e) => {
                            const selectedLink = e.target.value;
                            const foundItem = faqpages.find(
                              (x) => x.link === selectedLink || x.value === selectedLink,
                            );
                            if (foundItem) {
                              setFaqSelected((prev) => {
                                const alreadyExist = prev.some((item) => item.link === foundItem.link);
                                if (alreadyExist) return prev;
                                return [...prev, foundItem];
                              });
                            }
                          }}
                          options={faqpages?.map((item) => ({
                            value: item.link,
                            label: item.name ? `${item.name} (${item.link})` : item.link,
                          }))}
                        />
                      </div>
                    )}
                    <div className="flex flex-wrap mt-2">
                      {faqSelected?.map((elemItem, index) => {
                        return (
                          <div
                            key={index}
                            className="primary-bg-color flex items-center me-2 mb-2 min-w-[50px] text-xs text-left px-3 capitalize py-1.5 rounded-[6px]"
                          >
                            <span className="table-text">{elemItem?.name}</span>
                            <X
                              className="h-[14px] text-red-500 hover:text-red-700 min-w-[14px] max-w-[14px] ms-1 cursor-pointer"
                              onClick={(e) => removeSelectdPath(e, elemItem?.link)}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </DetailsComponent>
                </>
              )}
            </form>
          </div>
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-3 left-0">
          <div className="w-[90%] flex items-center justify-between lg:w-[70%] xl:w-[58%] mx-auto">
            <ButtonComponent
              variant="link"
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              icon={<ArrowLeft className="w-3 mr-1" />}
              className="text-[var(--table-text-color)]"
            >
              {t("lang_Go_To_FAQs")}
            </ButtonComponent>
            <div>
              <ButtonComponent
                variant="primary"
                disabled={isSubmitDisabled}
                loading={btnLoading}
                onClick={(e) => HandleUpdate(e)}
              >
                {t("lang_Update_FAQ")}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
      {html?.htmlPP && (
        <SourceCode
          open={html?.htmlPP}
          htmlCode={html?.code}
          closeCode={closeCode}
          saveHTML={saveHTML}
        />
      )}
    </>
  );
};

export default UpdateFaq;
